<template>
  <div class="volumes">
    <i class="fa fa-edit"
       @click="dialogObject = true"
    />
    <el-dialog
      custom-class="volumes-modal"
      append-to-body
      width="90%"
      :title="`Hастройка плана профессий по дням (сменам)`" :visible.sync="dialogObject">
      <div class="volumes">
        <div style="display: flex; justify-content: flex-start" v-if="plan"
        >
          <VolumeMultiple
            :type="type"
            :name="name"
            :propsValue="plan"
            :plan-row="tableData"
            @applyForAll="(a) => setVolumesAll(a)"
          >
            <el-button size="mini" type="default" style="width: 140px; margin-bottom: 10px">
              Распределить
            </el-button>
          </VolumeMultiple>
        </div>
        <el-table
          border
          :data="tableData"
          style="width: 100%">
          <el-table-column
            prop="name"
            label="Наименование"
            :width="130">
            <template slot-scope="scope">
              <div v-if="scope.$index !== 0" style="display: flex; align-items: center">
                <VolumeMultiple
                  :type="type"
                  :name="name"
                  @apply="(a) => setVolumes(a, scope.$index)"
                  :index="scope.$index"
                  :planRow="scope.row"
                />
                <strong style="padding-left: 10px">
                  Смена {{ scope.$index }}</strong>
              </div>
              <strong v-else>
                <strong>{{ jobName }}</strong>
              </strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            label="Итого объемы"
            width="135">
            <template slot-scope="scope">
              <strong v-if="scope.$index === 0">{{ getTotalSum(scope.$index) }}</strong>
              <strong v-else-if="type === 'JOB' || scope.$index === 0">{{ getTotalSum(scope.$index) }} {{ scope.$index }}</strong>
              <el-input v-else v-model="scope.row.all" @blur="(v) => scope.row.all = formatNumber(scope.row.all)"/>
            </template>
          </el-table-column>
          <el-table-column
            v-for="date in dates"
            :key="date"
            :prop="date"
            :label="date"
            width="150">
            <template slot-scope="scope">
              <div v-if="scope.$index !== 0">
                <el-input :value="scope.row[date]" @input="(v) => scope.row[date] = v.replace(',', '.')"
                          @blur="(v) => scope.row[date] = formatNumber(scope.row[date])"/>
              </div>
              <strong v-else>
                {{ getSummaryByDate(date) }}
              </strong>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="create-footer">
        <el-button @click="dialogObject = false">Закрыть</el-button>
        <el-button type="primary" @click="save">Сохранить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import _ from 'lodash';
import VolumeMultiple from "./VolumeMultiple";
import {toFixedWithoutZero, toFloat} from "../../../../utils/numberUtils";

export default {
  name: "Volumes",
  components: {VolumeMultiple},
  props: {
    jobName: "",
    table: [Object, Array],
    type: String,
    plan: [Number, String]
  },
  data() {
    return {
      dialogObject: false,
      tableData: [{
        total: this.$route.query.name,
      }],
      dates: [],
      months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль",
        "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]
    }
  },
  watch: {
    table: {
      deep: true,
      immediate: true,
      handler(table) {
        if (table && table.length) {
          setTimeout(() => {
            this.tableData = [
              {...this.tableData[0]},
              ...table.map((t) => {
                return t || this.tableData[1]
              })
            ]

          }, 100)
        }
      }
    }
  },
  methods: {
    setVolumesAll(tableData) {
      this.tableData = [...tableData]
      this.save()
    },
    formatNumber(v) {
      return toFloat(v)
    },
    formatValue(value) {
      return toFixedWithoutZero(value)
    },
    setVolumes(d, index) {
      this.tableData[index] = d
      this.tableData = [...this.tableData]
    },
    save() {
      const result = [];

      this.tableData.forEach((data, index) => {
        if (index) {
          result.push(data)
        }
      })

      const total = this.getTotalSum()

      this.$emit('save', {
        table: result,
        total
      })

      this.dialogObject = false;
    },
    getSummaryByDate(day) {
      let total = 0;

      this.tableData.forEach((data, index) => {
        if (index) {
          try {
            total += Number(data[day])
          } catch (e) {
          }
        }
      })
      return toFixedWithoutZero(total)
    },
    getTotalSum(index) {
      let total = 0;


      if (!index) {
        this.dates.forEach((d) => {
          total += this.getSummaryByDate(d)
        })

        return toFixedWithoutZero(total)
      }

      this.dates.forEach((d) => {
        try {
          total += Number(this.tableData[index][d])
        } catch (e) {
        }
      })

      const result = toFixedWithoutZero(total)
      if (this.plan) {
        const diff = total - this.plan;
        return (diff < 0.001 && diff > -0.001) ? this.plan : result
      }

      return result
    },
  },
  mounted() {
    const startDate = dayjs().startOf('month'); // начало текущего месяца
    const endDate = startDate.add(2, 'month').endOf('month'); // конец месяца через 2 месяца

    const tableRow = {};
    const dates = [];
    let current = startDate;

    while (current.isBefore(endDate) || current.isSame(endDate, 'day')) {
      const formatted = current.format('DD.MM.YYYY');
      dates.push(formatted);
      tableRow[formatted] = '';
      current = current.add(1, 'day');
    }

    this.dates = dates;

    this.tableData = [
      {...tableRow, all: null},
      {...tableRow, all: null},
      {...tableRow, all: null},
      {...tableRow, all: null},
    ];
  }
}
</script>

<style scoped lang="scss">
.volumes {
  max-width: 95%;
  margin: 0 auto;
}
.create-footer {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
</style>
<style lang="scss">
.volumes .el-dialog {
  max-width: 100% !important;
}

.volumes-modal {
  max-width: 100% !important;

}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Users/company/Volumes.vue